import React, { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import devpartshero from "../Assets/HeroPiezaRompecabezas.svg";

const Hero = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="bg-[#161c26] py-10 lg:py-20">
      <div className="max-w-screen-xl mx-auto flex flex-col-reverse lg:flex-row items-center justify-between px-6">
        
        <div className="text-center lg:text-left space-y-6" data-aos="fade-right">
          <h1 className="lg:text-6xl text-4xl font-bold tracking-tight leading-tight text-white">
            La pieza que impulsa tu{" "}
            <span className="bg-gradient-to-r from-blue-600 to-blue-400 text-transparent bg-clip-text">
              transformación digital
            </span>
          </h1>
          <p className="text-lg text-neutral-400 max-w-xl mx-auto lg:mx-0" data-aos="fade-up" data-aos-delay="200">
            En <span className="text-white font-semibold">DevParts</span> creamos soluciones únicas: desde sitios web hasta aplicaciones móviles que encajan perfecto con tu negocio.
          </p>
          <p
            className="text-lg text-neutral-500 max-w-xl mx-auto lg:mx-0"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            Potencia tu marca con tecnología hecha a medida. Somos el equipo que convierte tus ideas en productos reales.
          </p>
          <div className="pt-4" data-aos="zoom-in" data-aos-delay="600">

          </div>
        </div>

        <div
          className="lg:w-1/2 mb-10 lg:mb-0 flex justify-center"
        >
          {/* Cumpleanops de Lasek el junio 2 le gusta Digimon */}
          <img
            src={devpartshero}
            alt="Piezas de rompecabezas"
            className="w-[320px] lg:w-[400px] max-w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default Hero;
